import axios from "./api";
import { AuthResponse, ApiResponse, User } from "../types/user";

export const registerService = async (payload: any) => {
    const { data } = await axios.post<AuthResponse>("/auth/register", payload);
    return data;
};

export const loginService = async (payload: any) => {
    const { data } = await axios.post<AuthResponse>("/auth/login", payload);
    return data;
};

export const logoutService = async (refreshToken: string) => {
    const { data } = await axios.post<ApiResponse>("/auth/logout", { refreshToken });
    return data;
};

export const verifyEmailService = async (token: string) => {
    const { data } = await axios.post<ApiResponse>("/auth/verify-email", { token });
    return data;
};

export const resendVerificationService = async (email: string) => {
    const { data } = await axios.post<ApiResponse>("/auth/resend-verification", { email });
    return data;
};

export const forgotPasswordService = async (email: string) => {
    const { data } = await axios.post<ApiResponse>("/auth/forgot-password", { email });
    return data;
};

export const resetPasswordService = async (payload: any) => {
    const { data } = await axios.post<ApiResponse>("/auth/reset-password", payload);
    return data;
};

export const changePasswordService = async (payload: any) => {
    const { data } = await axios.put<ApiResponse>("/auth/change-password", payload);
    return data;
};

export const getProfileService = async () => {
    const { data } = await axios.get<ApiResponse<User>>("/auth/me");
    return data; // Currently returns ApiResponse<User>, but helper might expect User.
    // Wait, getProfileService usually returns User directly in many patterns? 
    // The previous implementation was `return data`.
    // The response is `{ success: true, data: User }`.
    // So `data.data` would be the user. 
    // BUT the previous implementation `return data` implies the caller handles the structure or the response was different.
    // Let's stick to returning `data` (the whole response object) and let the caller handle `data.data`.
    // Or I can verify what `api.ts` does. `api.ts` calls `get`, returns response. `data` is the body.
};

export const updateProfileService = async (payload: any) => {
    const { data } = await axios.put<ApiResponse<User>>("/auth/me", payload);
    return data;
};

export const getDismissedTutorialsService = async (): Promise<Record<string, string> | null> => {
    try {
        const { data } = await axios.get<ApiResponse<Record<string, string>>>("/tutorials/dismissed");
        return data.data ?? {};
    } catch {
        return null;
    }
};

export const dismissTutorialService = async (tutorialId: string, status: 'COMPLETED' | 'SKIPPED' = 'COMPLETED') => {
    try {
        await axios.post(`/tutorials/${tutorialId}/dismiss?status=${status}`);
    } catch {
        // Silently fail — don't affect user experience
    }
};
